export const sendEmailMessage = async (email: string): Promise<void> => {
  const uri = `mailto:${email}`;
  window.location.href = uri;
};

export const phoneCall = async (phone: string): Promise<void> => {
  const uri = `tel:${phone}`;
  window.location.href = uri;
};

export const sendWhatsAppMessage = async (phone: string): Promise<void> => {
  const uri = `https://wa.me/${phone}`;
  window.open(uri, '_blank', 'noopener,noreferrer');
};

export const sendSkypeMessage = async (
  skypeUsername: string
): Promise<void> => {
  const uri = `https://join.skype.com/invite/${skypeUsername}`;
  window.open(uri, '_blank', 'noopener,noreferrer');
};

export const sendMessengerMessage = async (name: string): Promise<void> => {
  const uri = `https://m.me/${name}`;
  window.open(uri, '_blank', 'noopener,noreferrer');
};

export const sendTelegramMessage = async (phone: string): Promise<void> => {
  const uri = `https://t.me/${phone}`;
  window.open(uri, '_blank', 'noopener,noreferrer');
};

export const emailLink = (email: string): string => {
  return `mailto:${email}`;
};

export const phoneLink = (phone: string): string => {
  return `tel:${phone}`;
};

export const whatsAppLink = (phone: string): string => {
  return `https://wa.me/${phone}`;
};

export const skypeLink = (skypeUsername: string): string => {
  return `https://join.skype.com/invite/${skypeUsername}`;
};

export const messengerLink = (name: string): string => {
  return `https://m.me/${name}`;
};

export const telegramLink = (phone: string): string => {
  return `https://t.me/${phone}`;
};

export const openWhatsappShare = (text: string, url: string): void => {
  const encodedText = encodeURIComponent(text);
  const encodedUrl = encodeURIComponent(url);
  const uri = `https://wa.me/?text=${encodedText}%20${encodedUrl}`;
  window.open(uri, '_blank', 'noopener,noreferrer');
};

export const openTwitterShare = (text: string, url: string): void => {
  const encodedText = encodeURIComponent(text);
  const encodedUrl = encodeURIComponent(url);
  const uri = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
  window.open(uri, '_blank', 'noopener,noreferrer');
};

export const openFacebookShare = (text: string, url: string): void => {
  const encodedText = encodeURIComponent(text);
  const encodedUrl = encodeURIComponent(url);
  const uri = `https://www.facebook.com/sharer/sharer.php?quote=${encodedText}&u=${encodedUrl}`;
  window.open(uri, '_blank', 'noopener,noreferrer');
};

export const openLinkedinShare = (url: string): void => {
  const encodedUrl = encodeURIComponent(url);
  const uri = `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`;
  window.open(uri, '_blank', 'noopener,noreferrer');
};

export const openMailShare = (text: string, url: string): void => {
  const encodedText = encodeURIComponent(text);
  const encodedUrl = encodeURIComponent(url);
  const uri = `mailto:?subject=${encodedText}&body=${encodedUrl}`;
  window.open(uri, '_blank', 'noopener,noreferrer');
};
